import { useState } from 'react';
import { api } from '../services/api';

const css = `
  .ab-ov { position: fixed; inset: 0; background: rgba(23,59,52,.55); z-index: 1000; display: flex; align-items: flex-end; justify-content: center; font-family: 'Inter', system-ui, sans-serif; }
  .ab-sheet { background: #F6F2EC; width: 100%; max-width: 480px; border-radius: 24px 24px 0 0; padding: 22px 20px calc(22px + env(safe-area-inset-bottom)); max-height: 92vh; overflow-y: auto; color: #222; animation: abUp .25s ease; }
  @keyframes abUp { from { transform: translateY(40px); opacity: 0; } to { transform: none; opacity: 1; } }
  .ab-x { float: right; background: none; border: 0; font-size: 26px; color: #6b6b64; width: 44px; height: 44px; margin: -10px -10px 0 0; cursor: pointer; }
  .ab-k { font-size: 11px; letter-spacing: .13em; text-transform: uppercase; font-weight: 700; color: #E4572E; }
  .ab-h { font-size: 24px; line-height: 1.15; font-weight: 800; color: #173B34; margin: 6px 0 12px; letter-spacing: -0.01em; }
  .ab-p { background: #fff; border: 2px solid #E4572E; border-radius: 16px; padding: 14px 16px; margin: 12px 0; }
  .ab-p b { font-size: 18px; color: #173B34; display: block; }
  .ab-p span { font-size: 13px; color: #6b6b64; }
  .ab-li { display: flex; gap: 10px; margin: 8px 0; font-size: 14.5px; line-height: 1.4; }
  .ab-li i { color: #E4572E; font-style: normal; font-weight: 800; }
  .ab-li.soon { opacity: .65; }
  .ab-btn { display: flex; align-items: center; justify-content: center; width: 100%; min-height: 54px; border: 0; border-radius: 14px; background: #E4572E; color: #fff; font-size: 16px; font-weight: 700; font-family: inherit; cursor: pointer; margin-top: 16px; }
  .ab-btn:disabled { opacity: .6; }
  .ab-btn2 { display: flex; align-items: center; justify-content: center; width: 100%; min-height: 48px; border: 1.5px solid #E3DCCF; background: #fff; border-radius: 14px; color: #173B34; font-size: 15px; font-weight: 700; font-family: inherit; cursor: pointer; margin-top: 10px; }
  .ab-err { background: #fdecea; border: 1px solid #f5c2bb; color: #9b2c1f; border-radius: 12px; padding: 10px 12px; font-size: 14px; margin-top: 12px; }
  .ab-ok { background: #e6f2ec; border: 1px solid #b9d9c8; color: #173B34; border-radius: 14px; padding: 16px; font-size: 15px; line-height: 1.45; font-weight: 600; margin-top: 12px; }
  @media (min-width: 768px) { .ab-ov { align-items: center; } .ab-sheet { border-radius: 24px; } }
`;

export function AbonnementModal({ onClose }) {
  const [state, setState] = useState('idle');
  const [error, setError] = useState('');
  const go = async () => {
    setState('loading'); setError('');
    try { await api.interetAbonnement(); setState('done'); }
    catch (e) { setError(e.message); setState('idle'); }
  };
  return (
    <div className="ab-ov" onClick={onClose}>
      <style>{css}</style>
      <div className="ab-sheet" onClick={e => e.stopPropagation()} role="dialog" aria-modal="true">
        <button className="ab-x" onClick={onClose} aria-label="Fermer">×</button>
        <div className="ab-k">Parcours Lancer</div>
        <h2 className="ab-h">Passe à l'action, un module à la fois</h2>
        <div className="ab-p"><b>Abonnement mensuel</b><span>Sans engagement. Tarif annoncé à l'ouverture.</span></div>
        <div className="ab-li"><i>✓</i>Google Business Profile</div>
        <div className="ab-li"><i>✓</i>Publicité Meta</div>
        <div className="ab-li"><i>✓</i>Premiers clients</div>
        <div className="ab-li"><i>✓</i>Réseaux sociaux, avec ton code promo Léa</div>
        <div className="ab-li soon"><i>+</i>Offre et prix, avis et fidélisation, plan 90 jours : bientôt</div>
        {error && <div className="ab-err">{error}</div>}
        {state === 'done' ? (
          <>
            <div className="ab-ok">C'est noté. On te prévient dès que l'abonnement ouvre.</div>
            <button className="ab-btn2" onClick={onClose}>Fermer</button>
          </>
        ) : (
          <>
            <button className="ab-btn" onClick={go} disabled={state === 'loading'}>{state === 'loading' ? 'Envoi...' : "Me prévenir à l'ouverture"}</button>
            <button className="ab-btn2" onClick={onClose}>Plus tard</button>
          </>
        )}
      </div>
    </div>
  );
}
